import { combineReducers } from 'redux';
import { createReduxHistoryContext } from 'redux-first-history';
import { createMemoryHistory } from 'history';
import { APP_BASE } from '../constants/branding';
import quests from './quests';
import publishing from './publishing';
import user from './user';
import stats from './stats';
import referal from './referal';
import partner from './partner';
import reports from './reports';
import uploads from './uploads';
import codes from './codes';
import tutorial from './tutorial';
import network from './network';
import languages from './languages';
import currencies from './currencies';

const createWrappedRouterReducer = (routerReducer, basename) => (
  state,
  action
) => {
  const nextState = routerReducer(state, action);
  if (basename && nextState?.location?.pathname?.startsWith(basename)) {
    const raw = nextState.location.pathname.slice(basename.length);
    const pathname = raw.startsWith('/') ? raw : `/${raw}`;
    return {
      ...nextState,
      location: {
        ...nextState.location,
        pathname,
      },
    };
  }
  return nextState;
};

const createRootReducer = (historyOrRouterReducer, basename = APP_BASE) => {
  let routerReducer;
  if (typeof historyOrRouterReducer === 'function') {
    routerReducer = historyOrRouterReducer;
  } else {
    const history =
      historyOrRouterReducer && historyOrRouterReducer.listen
        ? historyOrRouterReducer
        : createMemoryHistory();
    const ctx = createReduxHistoryContext({ history, basename });
    routerReducer = ctx.routerReducer;
  }

  return combineReducers({
    quests,
    publishing,
    user,
    stats,
    referal,
    partner,
    reports,
    uploads,
    router: createWrappedRouterReducer(routerReducer, basename),
    codes,
    tutorial,
    network,
    languages,
    currencies,
  });
};

export default createRootReducer;
